import { Avatar, type AvatarProps } from '@mui/material';
import { getPhotoUrl } from '@/utils/mainAppAssets';

function userInitial(
  referenceNo?: string | null,
  fullName?: string | null,
  displayName?: string | null
): string {
  const name = fullName?.trim() || referenceNo?.trim() || displayName?.trim() || 'U';
  return name.charAt(0).toUpperCase();
}

interface Props extends Omit<AvatarProps, 'src' | 'children'> {
  /** Prefer API-resolved absolute URL (production-safe). */
  photoUrl?: string | null;
  photoPath?: string | null;
  referenceNo?: string | null;
  fullName?: string | null;
  /** Fallback when reference_no / full_name unavailable (e.g. assertion userName). */
  displayName?: string | null;
}

export default function UserAvatar({
  photoUrl,
  photoPath,
  referenceNo,
  fullName,
  displayName,
  sx,
  ...rest
}: Props) {
  const photoSrc = photoUrl?.trim() || getPhotoUrl(photoPath);
  const initial = userInitial(referenceNo, fullName, displayName);

  return (
    <Avatar
      src={photoSrc || undefined}
      sx={{
        bgcolor: 'secondary.main',
        color: '#000',
        fontWeight: 700,
        ...sx,
      }}
      {...rest}
    >
      {initial}
    </Avatar>
  );
}
